import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { Entity } from '@state/entities';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ModalActions, ModalActionType } from '@component/modal';
import { ID } from '@state/base';

export interface InvestmentProfileSelectionWarningModalComponentData {
  entity: Entity;
  profileHasUserButNotInvestor: boolean;
  investorDetails: { email: string; id: ID; name: string };
}

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'fl-investment-profile-selection-warning-modal',
  templateUrl: './investment-profile-selection-warning-modal.component.html'
})
export class InvestmentProfileSelectionWarningModalComponent {
  modalActions: ModalActions;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: InvestmentProfileSelectionWarningModalComponentData,
    private dialogRef: MatDialogRef<InvestmentProfileSelectionWarningModalComponent>
  ) {
    this.setModalActions();
  }

  setModalActions(): void {
    this.modalActions = [
      {
        action: (): void => this.dialogRef.close(false),
        label: 'Cancel',
        type: ModalActionType.Close
      },
      {
        action: (): void => this.dialogRef.close(true),
        label: 'Add Member and Select Account',
        type: ModalActionType.Positive
      }
    ];
  }
}
